import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const GearModelState = Immutable.fromJS({
	gearModel: {
		modelDisplayName: '',
		modelNo: '',
		modelName: '',
		style: '',
		certificates: '',
		reinforcingFabric: '',
		outerShell: '',
		moistureBarrier: '',
		thermalLiners: ''
	},
	gearModelValidation: {
		modelDisplayName: {
			validationState: null,
			helpBlock: null
		},
		modelName: {
			validationState: null,
			helpBlock: null
		},
		style: {
			validationState: null,
			helpBlock: null
		},
		certificates: {
			validationState: null,
			helpBlock: null
		},
		reinforcingFabric: {
			validationState: null,
			helpBlock: null
		},
		outerShell: {
			validationState: null,
			helpBlock: null
		},
		moistureBarrier: {
			validationState: null,
			helpBlock: null
		},
		thermalLiners: {
			validationState: null,
			helpBlock: null
		}
	},
	alertStyle: null,
	alertMessage: null,
	showModal: false,
	showUploadModal: false,
	forInsert: true,
	allSizeTypes: []
});

const gearModelReducer = handleActions({
	CHANGE_GEARMODEL_VALUE: (state, { payload }) => {
		let gearModel = state.get('gearModel');
		return state.merge({
			gearModel: gearModel.set(payload.id, payload.value),
		})
	},
	FORM_SUBMIT_GEARMODEL: (state, { payload }) => {
		return state.merge({
			gearModel: payload.data.bean,
			gearModelValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	OPEN_GEARMODEL_MODAL: (state, { payload }) => {
		return state.merge({
			forInsert: payload.forInsert,
			showModal: true
		})
	},
	OPEN_GEARMODEL_UPLOAD_MODAL: (state, { payload }) => {
		return state.merge({
			showUploadModal: true
		})
	},
	CLOSE_GEARMODEL_MODAL: (state, { payload }) => {
		return state.merge({
			gearModel: {
				modelDisplayName: '',
				modelNo: '',
				modelName: '',
				style: '',
				certificates: '',
				reinforcingFabric: '',
				outerShell: '',
				moistureBarrier: '',
				thermalLiners: ''
			},
			gearModelValidation: {
				modelDisplayName: {
					validationState: null,
					helpBlock: null
				},
				modelName: {
					validationState: null,
					helpBlock: null
				},
				style: {
					validationState: null,
					helpBlock: null
				},
				certificates: {
					validationState: null,
					helpBlock: null
				},
				reinforcingFabric: {
					validationState: null,
					helpBlock: null
				},
				outerShell: {
					validationState: null,
					helpBlock: null
				},
				moistureBarrier: {
					validationState: null,
					helpBlock: null
				},
				thermalLiners: {
					validationState: null,
					helpBlock: null
				}
			},
			alertStyle: null,
			alertMessage: null,
			showModal: false,
			showUploadModal: false,
			forInsert: true
		})
	},
	FIND_GEARMODEL: (state, { payload }) => {
		return state.merge({
			gearModel: payload.data
		})
	},
	BEFORE_UPLOAD_MODEL_TEMPLATE: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: '資料處理中，請稍後。'
		})
	},
	AFTER_UPLOAD_MODEL_TEMPLATE: (state, { payload }) => {
		return state.merge({
			gearModel: payload.data.bean,
			gearModelValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage
		})
	},
	FIND_ALL_MODEL_SIZETYPES: (state, { payload }) => {
		return state.merge({
			allSizeTypes: payload.data
		})
	},
}, GearModelState);

export default gearModelReducer;


// WEBPACK FOOTER //
// ./src/reducers/gearModelReducer.js